import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[appWidth]'
})
export class DisplayWidthDirective {
  @Input()
  @HostBinding('style.width') width: string;

}
